import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';
import { Question } from './Question';

export class DropdownQuestion extends React.Component {
  onChange = (event) => {
    if (this.textBox) {
      this.textBox.value = '';
    }

    let textboxval = event.target.value;
    if (!isNaN(textboxval)) {
      textboxval = parseInt(textboxval, 10);
    }

    this.props.updateAnswer(
      this.props.questionnaireItem.questionnaireItemId,
      {
        listAnswerId: textboxval,
        otherOptionText: '',
      });

    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  getClassName() {
    if (this.textBox) {
      let dropdownval = this.dropDown.value;
      if (!isNaN(dropdownval)) {
        dropdownval = parseInt(dropdownval, 10);
      }
      const answer = this.props.questionnaireItem.listAnswers
        .find((la) => la.listAnswerId === dropdownval);
      return answer.isOtherTextValid === false
        ? 'form-group col-12 col-md-4 has-error is-invalid' : 'form-group col-12 col-md-4';
    }
    return 'form-group col-12 col-md-4';
  }

  textOnBlur = (event) => {
    let dropdownval = this.dropDown.value;
    if (!isNaN(dropdownval)) {
      dropdownval = parseInt(dropdownval, 10);
    }
    this.props.updateAnswer(
      this.props.questionnaireItem.questionnaireItemId,
      {
        listAnswerId: dropdownval,
        otherOptionText: event.target.value,
      });

    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  isShowTextBox() {
    return this.props.disabled ? this.isShowTextBoxDisabled() : this.isShowTextBoxNormal();
  }

  isShowTextBoxNormal() {
    if (this.dropDown === undefined) {
      return false;
    }

    const selectedAnswer =
      this.props.questionnaireItem.listAnswers
        .find(answer => answer.listAnswerId.toString() === this.dropDown.value);
    return selectedAnswer ? selectedAnswer.isOtherOption : false;
  }

  isShowTextBoxDisabled() {
    if (this.props.answerItem) {
      const selectedAnswer =
      this.props.questionnaireItem.listAnswers
        .find(answer => answer.listAnswerId === this.props.answerItem.listAnswerId);
      return selectedAnswer ? selectedAnswer.isOtherOption : false;
    }
    return false;
  }

  render() {
    const { questionnaireItem, answerItem } = this.props;
    const opts = {};
    const selectOpts = {};
    opts.disabled = this.props.disabled;
    selectOpts.disabled = this.props.disabled;
    if (this.isShowTextBoxDisabled) {
      if (answerItem) {
        opts.value = answerItem.otherOptionText || '';
      }
    }
    if (this.props.answerItem) {
      selectOpts.value = answerItem.listAnswerId || '';
    }

    return (
      <div className="form-group question-area" data-qa-item="dropdown_question_type">
        <Question questionNumber={questionnaireItem.questionNumber}
          isValid={ questionnaireItem.isValid }
          formattedText={questionnaireItem.formattedText}
          isRequired={questionnaireItem.isRequired}
        />
        <div className="row">
          <div className="form-group col-12 col-md-4">
            <select className={questionnaireItem.isValid === false ? "form-select is-invalid": "form-select"}
              ref={ (dropdown) => { this.dropDown = dropdown; } }
              onChange={this.onChange}
              {...selectOpts}
            >
              <option></option>
              {this.props.questionnaireItem.listAnswers.map(answer =>
              (<option key={answer.listAnswerId} value={answer.listAnswerId}>
                {answer.formattedText}
               </option>))}
            </select>
            {
            questionnaireItem.isValid === false
              ? <span data-qa-item={ 'question_is_invalid_' + questionnaireItem.questionNumber } className="invalid-feedback">
                  <FormattedMessage {...messages.error.required} />
                </span>
              : null
          }
          </div>
          { this.isShowTextBox() ?
            <div className={ this.getClassName() }>
              <input type="text"
                ref={ (textbox) => { this.textBox = textbox; } }
                className="form-control" onBlur={this.textOnBlur} maxLength="2000" {...opts}
              />
            </div> : null }
        </div>
      </div>
    );
  }
}

DropdownQuestion.propTypes = {
  questionnaireItem: PropTypes.object,
  updateAnswer: PropTypes.func,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
  answerItem: PropTypes.object,
};
